import ActiveIngredientCurationList from '../components/ActiveIngredientCuration';
import ActiveIngredient from '../components/ActiveIngredientCuration/ActiveIngredient';

const ACTIVE_INGREDIENT_CURATION_ROUTES = [
  {
    id: 'active_ingredient_curation',
    path: '/active_ingredient_curation',
    component: ActiveIngredientCurationList,
    exact: true
  },
  {
    id: 'active_ingredient_curation_detail',
    path: '/active_ingredient_curation/:id',
    component: ActiveIngredient,
    exact: true
  }
];

export default ACTIVE_INGREDIENT_CURATION_ROUTES;
